module.exports = __webpack_public_path__ + "media/images/browsers/vivaldi-9168cfe75e31bdacea8431d8867c22cf.svg";